import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import { withRouter } from 'react-router';
import { compose } from 'react-apollo';
import { connect } from 'react-redux';
import { connectLean } from 'lean-redux';
import { useAssessmentProgressComponent } from 'chameleon/ui-stack/ui/units/subunit-content/ppc';

const getUnitResources = (unitsState, unitId) =>
  (unitsState[`unit-${unitId}`] || {}).resources || {};

const PersonalProgressCheckAction = (props) => {
  const {
    unitsState,
    teacherAssignments,
    unitNumber,
    router,
    isTeacher,
    isAdminOrCoordinator,
    params: { subject: subjectId },
    courseOutlineData,
    item,
    disablePpcAutoAssignFlag,
    assessmentDataCache,
    subjectData,
  } = props;
  const { unit = {}, subunitType } = courseOutlineData || {};

  const { areAssignmentStatusesLoaded } = unitsState;
  const [isLoading, setIsLoading] = useState(!isAdminOrCoordinator);
  const [resourceStatuses, setResourceStatuses] = useState({});

  const { unitId, title: unitTitle } = unit || {};
  const { getProgressCheckResourceAction } = useAssessmentProgressComponent({
    router,
    subjectData,
    subjectId,
    subunitType,
    disablePpcAutoAssignFlag,
    resourceStatuses,
    unitId,
    unitNumber,
    unitTitle,
    isAdminOrCoordinator,
    isTeacher,
    isStudent: false,
    assessmentDataCache,
    assignments: teacherAssignments || [],
  });

  useEffect(() => {
    if (!teacherAssignments) {
      setIsLoading(false);
    }
  }, [teacherAssignments]);

  useEffect(() => {
    if (
      !isAdminOrCoordinator &&
      Object.keys(courseOutlineData || {}).length > 0
    ) {
      setIsLoading(false);
    }
  }, [courseOutlineData]);

  useEffect(() => {
    if (
      !isAdminOrCoordinator &&
      areAssignmentStatusesLoaded &&
      unit &&
      unit.unitId
    ) {
      const resources = getUnitResources(unitsState, unit.unitId);
      setResourceStatuses(resources);
    }
  }, [unitsState, unit]);

  if (isLoading) {
    return (
      <LoadingSpinner
        containerClassName="flex items-center justify-center"
        width={20}
        height={20}
      />
    );
  }

  return getProgressCheckResourceAction(item);
};

PersonalProgressCheckAction.propTypes = {
  unitsState: PropTypes.object.isRequired,
  teacherAssignments: PropTypes.array.isRequired,
  unitNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  router: PropTypes.object.isRequired,
  isStudent: PropTypes.bool,
  isTeacher: PropTypes.bool,
  isAdminOrCoordinator: PropTypes.bool,
  params: PropTypes.object.isRequired,
  courseOutlineData: PropTypes.object,
};

PersonalProgressCheckAction.defaultProps = {
  isStudent: false,
  isTeacher: false,
  isAdminOrCoordinator: false,
  courseOutlineData: null,
};

const mapStateToProps = (state) => {
  const {
    userData: { isStudent, isTeacher, isAdmin, isCoordinator },
    featureFlag,
    assessmentDataCache,
    subject,
  } = state;
  const isAdminOrCoordinator = isAdmin || isCoordinator;

  return {
    isStudent,
    isTeacher,
    isAdminOrCoordinator,
    disablePpcAutoAssignFlag: featureFlag.disable_ppc_auto_assign,
    assessmentDataCache,
    subjectData: subject.data,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps),
  connectLean({
    scope: 'units',
    mapState: (state) => ({
      unitsState: state,
    }),
  }),
)(PersonalProgressCheckAction);
